import Api from "../../Api";
import { message } from "antd";
import { modifyError } from "../../Validation/ModifyErrros";

const extractUploadError = (data) => {
  if (!data) return "Unknown error occurred.";
  return (
    data?.e?.response?.message ||
    data?.e?.message ||
    data?.message ||
    "Unknown error occurred."
  );
};

export const uploadFile = async (file, imageType, real, oldFileName = null) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (real) formData.append("real", real);
    formData.append("imageSubType", imageType?.subType);
    if (oldFileName) formData.append("oldFileName", oldFileName);
    let res = await Api.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const data = res?.data;
    if (data?.status === false) {
      const errMsg = extractUploadError(data);
      message.error(errMsg);
      return { error: errMsg, e: data?.e };
    }
    return data;
  } catch (e) {
    let error = modifyError(e);
    message.error(error.message);
    return { error: error.message };
  }
};
export const uploadFileMobile = async (file, imageType, real, silent = false, oldFileName = null) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (real) formData.append("real", real);
    formData.append("imageSubType", imageType?.subType);
    formData.append("imageType", imageType?.type);
    if (oldFileName) formData.append("oldFileName", oldFileName);
    let res = await Api.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const data = res?.data;
    if (data?.status === false) {
      const errMsg = extractUploadError(data);
      if (!silent) message.error(errMsg);
      return { error: errMsg, e: data?.e };
    }
    return data;
  } catch (e) {
    let error = modifyError(e);
    if (!silent) message.error(error.message);
    return { error: error.message };
  }
};

export const downloadFile = async (fileName, downloadName) => {
  try {
    const response = await Api.post(
      `/upload/download/`,
      { fileName },
      {
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    // Create a link and trigger download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", downloadName || fileName);
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("File download failed:", error);
    alert("Failed to download file.");
  }
};
export const uploadMultipleFile = async (files) => {
  console.log(files);
  try {
    const formData = new FormData();
    // formData.append("file", files);
    files.forEach((file, index) => {
      formData.append(`files`, file, file.name);
    });

    let res = await Api.post("/upload/multi", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res?.data;
  } catch (e) {
    console.log(e);
    return { error: "Something Wrong" };
  }
};

export const clearCache = async () => {
  try {
    let res = await Api.get("/upload/clearCache");

    return res?.data;
  } catch (e) {
    console.log(e);
    return { error: "Something Wrong" };
  }
};
